import { api } from "./http-client";
import { PaymentTransactionsPage, ListPaymentsParams } from "../interfaces/payment-transaction.interface";

export const paymentTransactionsService = {
  list: async (params: ListPaymentsParams): Promise<PaymentTransactionsPage> => {
    const res = await api.request<PaymentTransactionsPage>({
      url: "/admin/payments",
      method: "GET",
      params,
    });
    return res.data;
  },
};
